// What the app did just before a feedback report: the last taps, screens, failed calls and toasts, plus recent page
// errors. Memory only (lost on reload). The β feedback sheet attaches both lists; uncaught errors are also sent to
// /api/client-errors by feedback/errors.ts. No imports, so any module can leave a crumb.
export interface Crumb { t: string; e: string }
export interface PageError { t: string; message: string; stack?: string; screen?: string }

const TRAIL_MAX = 40;
const ERRORS_MAX = 15;
const trail: Crumb[] = [];
const errors: PageError[] = [];

/** Local wall-clock time, 'HH:MM:SS'. */
const now = () => new Date().toTimeString().slice(0, 8);

/** Record one step ("tap Start", "screen T", "api POST /api/cards/c1/start -> 500 internal"). */
export function crumb(e: string): void {
  const text = e.replace(/\s+/g, ' ').trim().slice(0, 160);
  if (!text) return;
  const last = trail[trail.length - 1];
  if (last && last.e === text) { last.t = now(); return; } // repeated taps: keep the latest time only
  trail.push({ t: now(), e: text });
  if (trail.length > TRAIL_MAX) trail.shift();
}

export function rememberError(err: Omit<PageError, 't'>): PageError {
  const e: PageError = { t: now(), message: err.message.slice(0, 500), ...(err.stack ? { stack: err.stack.slice(0, 2000) } : {}), ...(err.screen ? { screen: err.screen } : {}) };
  errors.push(e);
  if (errors.length > ERRORS_MAX) errors.shift();
  return e;
}

export const recentTrail = (): Crumb[] => trail.map((c) => ({ ...c }));
export const recentErrors = (): PageError[] => errors.map((e) => ({ ...e }));
